import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageIntro from '@/components/feature/PageIntro';
import CTASection from '@/components/feature/CTASection';
import { faqs } from '@/mocks/pages';

export default function SupportPage() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <PageIntro crumb="Support" eyebrow="Support & FAQ" title="SUPPORT AT EVERY STEP." docTitle="Support & FAQ | NORTHLINE Flow Systems">
          <p>Find guidance on product selection, technical information and the quotation process.</p>
        </PageIntro>

        <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-20 md:pb-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
            <h2 className="lg:col-span-4 eyebrow text-foreground-500">Frequently asked questions</h2>
            <div className="lg:col-span-8 border-t border-background-200">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q} className="border-b border-background-200">
                    <h3>
                      <button
                        type="button"
                        id={`faq-btn-${i}`}
                        aria-expanded={isOpen}
                        aria-controls={`faq-panel-${i}`}
                        onClick={() => setOpen(isOpen ? null : i)}
                        className="w-full flex items-center justify-between gap-6 py-6 text-left cursor-pointer group focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 rounded-sm"
                      >
                        <span className={`text-base md:text-lg transition-colors ${isOpen ? 'text-primary-500' : 'text-foreground-950 group-hover:text-primary-500'}`}>{f.q}</span>
                        <span className="w-6 h-6 shrink-0 flex items-center justify-center text-foreground-600">
                          <i className={`ri-add-line text-lg transition-transform duration-[450ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpen ? 'rotate-45' : ''}`} />
                        </span>
                      </button>
                    </h3>
                    <div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-btn-${i}`} className={`grid transition-[grid-template-rows] duration-[450ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                      <div className="overflow-hidden">
                        <p className="pb-6 pr-10 text-[15px] leading-relaxed text-foreground-600 max-w-2xl">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <CTASection title="NEED HELP WITH A SPECIFIC REQUIREMENT?" />
      </main>
      <Footer />
    </>
  );
}